// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2rKeJ","alert":"SettungsInbox_alert__1dHGX"};